<template>
  <el-form-item
    :label="item.label"
    :prop="`${item.field}`"
    :hidden="item.options.hidden"
    v-if="item.showed"
    :rules="[
      {
        required: item.required || false,
        message: item.label + '为必填字段',
      },
    ]"
  >
    <el-date-picker
      v-model="$attrs.model[item.field]"
      :ref="item.field"
      type="date"
      format="yyyy 年 MM 月 dd 日"
      value-format="yyyy-MM-dd"
      align="left"
      :disabled="item.options.disabled"
      :style="{ width: item.options.width || '100%' }"
      :placeholder="item.options.placeholder"
    >
    </el-date-picker>
  </el-form-item>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  created() {
    //console.log(this.$attrs);
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
